import React, { useEffect } from 'react'
import { Alert, Container } from '@mui/material'
import CaptchaModal from 'src/components/CaptchaModal'
import HelpAndSupport from 'src/components/HelpAndSupport'
import MobileApp from 'src/components/MobileApp'
import useLocation from 'src/hooks/useLocation'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import PageHeader from './components/PageHeader'
import RenderCardSearchResults from './components/RenderCardSearchResults'
import {
  closeCaptchaModal,
  setCaptchaToken,
  setPayload,
} from './ducks/home.reducer'
import { SmartCheckForm } from './components'

const HomePage: React.FC = () => {
  const { payload, captchaModalOpen, scanBlocked, scanBlockedReason } =
    useAppSelect((state) => state.home)
  const dispatch = useAppDispatch()
  const { location } = useLocation()

  // Set location on load page for the first time.
  useEffect(() => {
    if (!location?.latitude || !location.longitude) return

    if (!payload.longitude || !payload.latitude) {
      dispatch(setPayload({ ...payload, ...location }))
    }
  }, [location])

  return (
    <>
      <PageHeader />
      {scanBlocked && (
        <Container maxWidth="md" sx={{ mt: 4 }}>
          <Alert severity="error" variant="filled">
            {scanBlockedReason}
          </Alert>
        </Container>
      )}
      <SmartCheckForm />
      <RenderCardSearchResults />
      <MobileApp />
      <HelpAndSupport />
      <CaptchaModal
        open={captchaModalOpen}
        onToken={(token) => {
          dispatch(setCaptchaToken(token))
          dispatch(closeCaptchaModal())
        }}
        onClose={() => {
          dispatch(closeCaptchaModal())
        }}
      />
    </>
  )
}

export default HomePage
